import React from "react";
import {connect} from "react-redux";
import {Route, Switch, withRouter} from "react-router-dom";
import PollPortal from "./PollPortal";
import PortalAuthContainer from "../PortalAuthContainer";
import PageNotFoundPage from "../common/errorPages/404";
import addTracking from "../../helpers/addTracking";
import ExpiredPoll from "./ExpiredPoll";

class PollPortalContainer extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        addTracking();
    }

    render() {
        return (
            <div>
                <Switch>
                    <Route exact path={"/pollPortal/auth/:nonce"} render={PortalAuthContainer}/>
                    <Route exact path={"/pollPortal/expired"} render={ExpiredPoll}/>
                    <Route path={"/pollPortal"} render={PollPortal}/>
                    <Route component={PageNotFoundPage}/>
                </Switch>
            </div>
        );
    }
}

export default withRouter(connect()(PollPortalContainer));
